import { Subscription } from "rxjs";
import { ResolutionString } from "src/assets/tradingview/charting_library/charting_library";

export interface TVBar {
  time: number;
  open: number;
  close: number;
  high: number;
  low: number;
}

export enum Resolutions {
  M1 = '1',
  M5 = '5',
  M15 = '15',
  M30 = '30',
  M45 = '45',
  M60 = '60',
  M120 = '120',
  M240 = '240',
  M360 = '360',
  M720 = '720',
  D1 = '1D',
  W1 = '1W'
}

export interface RealtimeCandleSubscription {
  pair: string;
  resolution: ResolutionString;
  uuid: string;
  update: Function;
  resetHistory: Function;
  subscription?: Subscription;
}

export const MaximumAllowedDurations = {
  [Resolutions.M1]      : 1440      * 60,
  [Resolutions.M5]      : 7200      * 60,
  [Resolutions.M15]     : 21600     * 60,
  [Resolutions.M30]     : 43200     * 60,
  [Resolutions.M45]     : 64800     * 60,
  [Resolutions.M60]     : 86400     * 60,
  [Resolutions.M120]    : 172800    * 60,
  [Resolutions.M240]    : 345600    * 60,
  [Resolutions.M360]    : 518400    * 60,
  [Resolutions.M720]    : 1036800   * 60,
  [Resolutions.D1]      : 2073600   * 60,
  [Resolutions.W1]      : 4147200   * 60
}
